import * as yup from "yup";

import { PHONE_NUMBER_REGEX } from "@constants";
import { Translations, i18n } from "@i18n";
import { TrustedContactFormValues } from "./types";

export const validationSchema: yup.SchemaOf<TrustedContactFormValues> = yup.object().shape({
  firstName: yup.string().required(i18n.t(Translations.TrustedContactRouteInputFirstNameRequired)),
  lastName: yup.string().required(i18n.t(Translations.TrustedContactRouteInputLastNameRequired)),
  email: yup
    .string()
    .email(i18n.t(Translations.TrustedContactRouteInputEmailInvalid))
    .required(i18n.t(Translations.TrustedContactRouteInputEmailRequired)),
  phoneNumber: yup
    .string()
    .required(i18n.t(Translations.TrustedContactRouteInputPhoneNumberRequired))
    .matches(PHONE_NUMBER_REGEX, i18n.t(Translations.TrustedContactRouteInputPhoneNumberInvalid)),
});
